export var PDP_GET_IT_BY_TOOLTIP_COPY = "This delivery estimate is based on the time it takes the brand to ship your order, and the time it takes the carrier to deliver it.";
